<form fxLayout="column" name="coupon-form">
  <div fxLayout="row">
    <mat-form-field appearance="outline" fxFlex>
      <mat-label>Code</mat-label>
      <input
        name="code"
        matInput
        [(ngModel)]="coupon.code"
        type="text"
        required
        style="text-transform: uppercase;"
      />
    </mat-form-field>
    &nbsp;&nbsp;&nbsp;
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Enabled?</mat-label>
      <mat-slide-toggle
        [checked]="coupon.enabled"
        (change)="coupon.enabled = $event.checked"
        >{{ coupon.enabled ? "Enabled" : "Disabled" }}</mat-slide-toggle
      >
      <textarea matInput hidden></textarea>
    </mat-form-field>
  </div>
  <mat-form-field appearance="outline">
    <mat-label>Type</mat-label>
    <mat-select [(ngModel)]="coupon.type" name="type" required>
      <mat-option [value]="'PERCENTAGE'">
        Percentage
      </mat-option>
      <mat-option [value]="'AMOUNT'">
        Amount
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field appearance="outline" *ngIf="coupon.type === 'PERCENTAGE'">
    <mat-label>Value</mat-label>
    <input
      name="value"
      matInput
      [ngModel]="coupon.value * 100"
      (ngModelChange)="coupon.value = $event / 100"
      type="number"
      min="0"
      max="100"
      required
    />
    <mat-icon
      [inline]="true"
      matSuffix
      class="mat-typography"
      style="width: 24px; height: 24px; font-size: 24px;"
      >%</mat-icon
    >
  </mat-form-field>
  <mat-form-field appearance="outline" *ngIf="coupon.type === 'AMOUNT'">
    <mat-label>Value</mat-label>
    <input
      name="value"
      matInput
      [(ngModel)]="coupon.value"
      type="number"
      min="0"
      required
    />
    <mat-icon matSuffix>euro_symbol</mat-icon>
  </mat-form-field>
  <mat-form-field appearance="outline">
    <mat-label>Expire</mat-label>
    <input
      name="expire"
      matInput
      readonly
      [matDatepicker]="pickerExpire"
      [(ngModel)]="coupon.expire"
      (click)="pickerExpire.open()"
      required
    />
    <mat-datepicker-toggle
      matSuffix
      [for]="pickerExpire"
    ></mat-datepicker-toggle>
    <mat-datepicker #pickerExpire></mat-datepicker>
  </mat-form-field>
  <div fxLayout="row">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Usage Limit</mat-label>
      <mat-slide-toggle
        [checked]="coupon.limit > 0"
        (change)="$event.checked ? (coupon.limit = 1) : (coupon.limit = null)"
        >{{ coupon.limit > 0 ? "Yes" : "Without limits" }}</mat-slide-toggle
      >
      <textarea matInput hidden></textarea>
    </mat-form-field>
    &nbsp;&nbsp;&nbsp;
    <mat-form-field appearance="outline" *ngIf="coupon.limit > 0">
      <mat-label>Limit</mat-label>
      <input
        name="limit"
        matInput
        [(ngModel)]="coupon.limit"
        type="number"
        min="1"
        required
      />
      <span matSuffix>times</span>
    </mat-form-field>
    <div fxFlex></div>
  </div>
  <mat-form-field appearance="outline">
    <mat-label>Notes</mat-label>
    <textarea
      rows="5"
      name="notes"
      matInput
      [(ngModel)]="coupon.notes"
    ></textarea>
  </mat-form-field>
</form>
